export default "__VITE_ASSET__Cw4TSoCP__"